import { AuthLayout, AuthShell, ForgotPasswordForm } from '@features/auth';

/** Forgot-password route — Type A layout wrapping the request-reset form. */
const ForgotPasswordPage = () => (
  <AuthLayout>
    <AuthShell>
      <ForgotPasswordForm />
    </AuthShell>
  </AuthLayout>
);

export default ForgotPasswordPage;
